<template>
  <div id="app" class="app">
    <div class="downapp" @click="downApp">立即下载</div>
  </div>
</template>
<script>
import headBack from "../common/head-back";
//接口地址
import api from "../../api/index";
//toast组件
import tips from "@/estoast";
import util from "@/utils/util";
import store from "@/store";
import * as types from "../../store/types";
import { mapGetters } from "vuex";

export default {
  name: "app",
  data() {
    return {
      msg: "",
      cid: null
    };
  },
  mounted() {
    this.$point.init(new Date());
    store.dispatch("hideLoading");

    var channelId = this.$route.params.channelId;
    console.log("sharchannelIdeid:" + channelId);
    // this.type =type;
    // this.shareid =shareid;
    // if(!util.isNum(this.channelId)){
    //     tips.toast("地址不合法")
    //     this.$router.push("/index");
    // }
    store.commit(types.SET_CHANNEL, channelId);
    this.cid = channelId;
  },
  methods: {
    downApp() {
      var ua = window.navigator.userAgent.toLowerCase();
      this.$point.eventuid("down_app_calc_" + this.cid, this.cid, "down_app");
      window.location.href =
        "http://wap.haoyunba.com/apk/clac/clac_a_sf_ss1.apk";
    }
  },

  components: {
    headBack
  }
};
</script>
<style  scoped>
.app {
  width: 750px;
  height: 2982px;
  background: url("../../assets/img/app_down_back.png");
  background-size: 100% 100%;
}
.downapp {
  width: 100%;
  height: 110px;
  background: linear-gradient(90deg, #ffd6aa 0%, #fdb284 100%);
  left: 0;
	position: fixed;
	bottom: 0;
  font-size: 36px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #0c285c;
  line-height: 110px;
}
</style>


// WEBPACK FOOTER //
// src/components/downapp/downCalcbaidu.vue